import React from 'react';

import type { NLPSearchResultSource } from '../../../ai-answer-dialog/types';
import { AppIcon } from '../app-icon/app-icon';

import { IconStack } from './icon-stack';

const DEFAULT_MAX_SOURCES_IN_STACK = 3;

type SourcesStackProps = {
	maxSourcesInStack?: number;
	sources: NLPSearchResultSource[];
	testId?: string;
};

export function SourcesStack({ maxSourcesInStack, sources, testId }: SourcesStackProps) {
	if (sources.length === 0) {
		return null;
	}

	const sourcesForIconStack: NLPSearchResultSource[] = [];
	const sourceProductsMap: Record<string, boolean> = {};
	maxSourcesInStack = maxSourcesInStack ?? DEFAULT_MAX_SOURCES_IN_STACK;

	for (let i = 0; i < sources.length; i++) {
		const source = sources[i];

		if (source.product && !sourceProductsMap[source.product]) {
			sourcesForIconStack.push(source);
			sourceProductsMap[source.product] = true;
		} else if (!source.product && !sourceProductsMap.Unknown) {
			sourcesForIconStack.push(source);
			sourceProductsMap.Unknown = true;
		}

		if (sourcesForIconStack.length === maxSourcesInStack) {
			break;
		}
	}

	const appIcons = sourcesForIconStack.map((source) => (
		<AppIcon
			app={source.product}
			data-testid={`app-icon-${source.ari}`}
			key={source.ari}
			size="xxsmall"
		/>
	));
	return appIcons.length > 0 ? <IconStack testId={testId}>{appIcons}</IconStack> : null;
}
